import TogglesLocal from './TogglesLocal';

let configCatApiKey = process.env.REACT_APP_CONFIGCAT_API_KEY
let configCatMode = process.env.REACT_APP_CONFIGCAT_MODE

if (configCatMode === '365') {
    configCatApiKey = process.env.REACT_APP_CONFIGCAT_API_KEY_DEV_365
} else if (configCatMode === 'APP') {
    configCatApiKey = process.env.REACT_APP_CONFIGCAT_API_KEY_APP
}

//@ts-ignore
const isClient = typeof window !== 'undefined'
const isServer = typeof process !== 'undefined'

let configCatClient

if (isClient) {
    const configcatJS = require('configcat-js')
    configCatClient = configcatJS.getClient(configCatApiKey, configcatJS.PollingMode.AutoPoll);
} else if (isServer) {
    const configcatSSR = require('configcat-js-ssr')
    configCatClient = configcatSSR.getClient(configCatApiKey, configcatSSR.PollingMode.AutoPoll);
}

configCatClient.waitForReady().then()

class TogglesV2 {

    static isEnabled(toggle: string, email?: string): boolean {
        const localValue = this.toggleLocalValue(toggle);
    
        const snapshot = configCatClient.snapshot();
        const userObject = email
            ? { identifier: email, email: email }
            : undefined; 

        const configCatValue = snapshot.getValue(toggle, false, userObject);
    
        const result = localValue ?? configCatValue;
        return Boolean(result);
    }

    static async isEnabledAsync(toggle) {
        const localValue = this.toggleLocalValue(toggle);
        await configCatClient.waitForReady()
        const snapshot = configCatClient.snapshot();
        const configCatValue = await snapshot.getValue(toggle, false)
        const result = localValue ?? configCatValue
        return Boolean(result)
    }

    static close() {
        configCatClient = null
    }

    static toggleLocalValue(toggle) {
        let value;
        if (TogglesLocal.hasOwnProperty(toggle)) {
            value = TogglesLocal[toggle];
        }
        return value;
    }

}

export { TogglesV2, configCatClient }

export default TogglesV2